// extracted by mini-css-extract-plugin
export default {"section":"src-components-ImageDraggableDisplay-css-module__section--A-JRR"};